<template>
<v-container fluid class="secondary">
<v-card class="pa-3 primary" elevation="11" >  
<v-card-title>
      <v-row justify="center" align="center">
        
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            single-line
            :label="$t('producttable.searchLabel')"
            outlined
            hide-details
            class="tertiary font-weight-black mx-8"
          ></v-text-field>
      </v-row>
      
    </v-card-title>
    <v-row justify="center" align="center">
      <v-chip label class="pa-5 ma-3 quaterny text-h6" >
        <v-icon
        large
        color="blue darken-4"
      >mdi-pencil</v-icon>{{$t('producttable.helpModif')}}
      </v-chip>
      <v-chip label class="pa-5 ma-3  quaterny text-h6">
        <v-icon
        large
        
        color="red darken-4"
        class="ma-1"
      >mdi-delete</v-icon>{{$t('producttable.helpDelete')}}
      </v-chip>
      <v-chip label class="pa-5 ma-3 quaterny text-h6">
       <v-icon
       large
        color="yellow accent-4"
        class="ma-1"
      >mdi-plus</v-icon>{{$t('producttable.helpBuy')}}
      </v-chip>
      
      
    </v-row>
    <v-data-table
    :headers="headers"
    :items="products"
    class="pa-3 ma-5 elevation-1 tertiary textTable--text font-weight-black text-h3"
    :search="search"
  >
    <template v-slot:[`item.name`]="{item}">
      <h2 class="primary--text">{{item.name}}</h2>
    </template>
        
        
      
    <template v-slot:[`item.actions`]="{ item }">
      <v-row>
      <v-icon
        small
        class="ma-1"
        color="blue darken-4"
        @click="editItem(item)"
      >mdi-pencil</v-icon>
      <v-icon
        small
        @click="deleteProduct(item)"
        color="red darken-4"
        class="ma-1"
      >mdi-delete</v-icon>
      <v-icon
        color="yellow accent-4"
        class="ma-1"
        @click="buyProduct(item)"
      >mdi-plus</v-icon>
      </v-row>
      <v-dialog v-model="dialogBuy" max-width="80%" :retain-focus="false">
          <buyProd :product="prodactif" @update="confirmbuyprod"/>
        </v-dialog>
        
        <v-dialog
          v-model="dialogmodif"
          max-width="80%"
          :retain-focus="false"
          
        >
          <v-card>

          <modifProduct 
          @dialogend="closeForm"
          :prod="prod"
          :key="modifForm"
          />

          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px" :retain-focus="false">
          <v-card class="pa-5 secondary">
          <v-card class="primary pa-4">
            <v-card-title class="justify-center align-center">
            <h3 class="ml-5 quinty--text text-center">{{ $t('producttable.prodDeleteMessage') }}<div class="textMenu--text">{{prodactif.name}}</div></h3>
            </v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error font-weight-black black--text" @click="dialogDelete=false">{{ $t('cancel') }}</v-btn>
              <v-btn color="success font-weight-black black--text" @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
          </v-card>
        </v-dialog>
    </template>
   
  </v-data-table>
</v-card>
    
</v-container>
</template>

<script>
import modifProduct from '@/components/modifProduct'
import buyProd from '@/components/buyProd'
import {mapActions} from 'vuex'
          
export default {
   // eslint-disable-next-line vue/no-unused-components
   props:['products','headers'],
   components:{ modifProduct,buyProd },
    data () {
        return {            
            
            search:'',

            dialogDelete: false,
            
            propsdb:[],

            modfyingproduct:false,

            prodactif:[],
            prod:[],
            dialogmodif:false,
            modifForm:0,
            dialogBuy:false,

            
            

          }
    },
    computed:{
      
    },
    watch: {
      
    },
    mounted() {
          
        },
    methods:{
       ...mapActions([
        'deleteProd'
      ]),
      confirmbuyprod(){
        this.dialogBuy=false
      },
       
        editItem (item) {
        this.prod=item;
        this.modifForm+=1;
        this.dialogmodif = true
      },
      deleteProduct(item){
        this.dialogDelete = true
        this.prodactif=item
      },
      buyProduct(item){
        this.dialogBuy = true
        this.prodactif=item
      },

      deleteItemConfirm () {
        this.deleteProd(this.prodactif)
        this.dialogDelete = false
      },

      closeForm(){
        this.dialogmodif = false
      },
      
    },

    }
</script>

